var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailRejection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.805 4.98 22.0007 5.45067 22 6V9.975H20V8L12 13L4 8V18H16V20H4ZM12 11L20 6H4L12 11ZM19 20C18.7167 20 18.4793 19.904 18.288 19.712C18.0967 19.52 18.0007 19.2827 18 19V16C18 15.7167 18.096 15.4793 18.288 15.288C18.48 15.0967 18.7173 15.0007 19 15V14C19 13.45 19.196 12.9793 19.588 12.588C19.98 12.1967 20.4507 12.0007 21 12C21.5493 11.9993 22.0203 12.1953 22.413 12.588C22.8057 12.9807 23.0013 13.4513 23 14V15C23.2833 15 23.521 15.096 23.713 15.288C23.905 15.48 24.0007 15.7173 24 16V19C24 19.2833 23.904 19.521 23.712 19.713C23.52 19.905 23.2827 20.0007 23 20H19ZM20 15H22V14C22 13.7167 21.904 13.4793 21.712 13.288C21.52 13.0967 21.2827 13.0007 21 13C20.7173 12.9993 20.48 13.0953 20.288 13.288C20.096 13.4807 20 13.718 20 14V15Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRejection);
export default __webpack_public_path__ + "static/media/emailRejection.13f46c2ff15d2e99f82170c17a19c01d.svg";
export { ForwardRef as ReactComponent };